export default __webpack_public_path__ + "static/create-survey-95b5f8eac640f4f12d79d66cf3a2c9b5.png";